/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import DocumentTitle from 'react-document-title';
import QueryString from 'query-string';
import PropTypes from '../util/prop_types';
import config from '../config';
import { DatasetSelectors } from '../stores/dataset_selectors';
import { MapSelectors } from '../stores/map_selectors';
import { MapActionCreators } from '../stores/map_action_creators';
import { ViewSelectors } from '../stores/view_selectors';
import { ViewActionCreators } from '../stores/view_action_creators';
import Header from  '../shared_components/header';
import Menu from '../menu_components/menu';
import SidePanel from '../sidepanel_components/sidepanel';
import Omnibox from '../omnibox_components/omnibox';
import Map from '../map_components/map';

const mapStateToProps = (state) => {
  return {
    viewport: MapSelectors.getViewport(state),
    title: ViewSelectors.getTitle(state),
  }
}

const mapDispatchToProps = {
  setViewport: MapActionCreators.setViewport,
  setPopup: MapActionCreators.setPopup,
  clearPopup: MapActionCreators.clearPopup,
  setView: ViewActionCreators.setView,
};

class Home extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    viewport: PropTypes.immutable.map.isRequired,
    title: PropTypes.string,
    setViewport: PropTypes.func.isRequired,
    setPopup: PropTypes.func.isRequired,
    clearPopup: PropTypes.func.isRequired,
    setView: PropTypes.func.isRequired,
  };

  static contextTypes = {
    store: PropTypes.object,
  };

  componentDidMount() {
    const { params } = this.props.match;
    const query = QueryString.parse(this.props.location.search);

    //conversion of old building links to the new format
    if('vlist' in query) {
      this.props.history.push('/place/bldg-'+query.vlist);
    }

    //Set viewId
    const viewId = (params.viewId) ? params.viewId : 'default';
    this.props.setView(viewId);

    //set location
    if (params.lat && params.lng && params.zoom) {
      this.props.setViewport({
        center: [Number(params.lng), Number(params.lat)],
        zoom: [Number(params.zoom)],
      });
    }

    //set popup
    if (params.placeId) {
      this._setPopupFromUrl(params, 10);
    }

    //set seachQuery
    if (params.seachQuery) {
      console.log("search", params.seachQuery);
    }
  }

  componentWillReceiveProps(nextProps) {
    const state = this.context.store.getState();
    const lastParams = this.props.match.params;
    const nextParams = nextProps.match.params;
    const nextViewPort = nextProps.viewport;

    /*console.log("componentWillReceiveProps", {
      match: this.props.match == nextProps.match,
      location: this.props.location == nextProps.location,
      history: this.props.history == nextProps.history,
      viewport: this.props.viewport == nextProps.viewport,
      title: this.props.title == nextProps.title
    });*/

    //viewId Changes
    if (lastParams.viewId != nextParams.viewId) {
      const viewId = (nextParams.viewId) ? nextParams.viewId : 'default';
      this.props.setView(viewId);
    }

    //Viewport changes
    if (!this._didViewportUpdate(nextProps) && "lat" in nextParams) {
      const lat = nextViewPort.getIn(['center', 1], 0).toFixed(7);
      const lng = nextViewPort.getIn(['center', 0], 0).toFixed(7);
      const zoom = nextViewPort.getIn(['zoom', 0], 0).toFixed(1);

      //console.log("location     ", nextParams.lng, nextParams.lat, nextParams.zoom);
      //console.log("prev location", lastParams.lng, lastParams.lat, lastParams.zoom);
      //console.log("viewport     ", lng, lat, zoom);

      if (nextParams.lat != lat || nextParams.lng != lng || nextParams.zoom != zoom) {
        this.props.setViewport({
          center: [Number(nextParams.lng), Number(nextParams.lat)],
          zoom: [Number(nextParams.zoom)],
        });
      }
    }

    //Place changes
    if (lastParams.placeId != nextParams.placeId) {
      var curPopupFeature = MapSelectors.getPopup(state).get('feature', null);
      if (!(curPopupFeature && curPopupFeature.id == nextParams.placeId)) {
        if (nextParams.placeId) {
          this._setPopupFromUrl(nextParams, 10);
        }
        else {
          nextProps.clearPopup();
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.pendingPopup) {
      clearTimeout(this.pendingPopup);
    }
  }

  _didViewportUpdate = (nextProps) => {
    const nextViewport = nextProps.viewport;
    const oldViewport = this.props.viewport;

    if (oldViewport != nextViewport && !oldViewport.isEmpty()) {
      const didZoomUpdate = !oldViewport.get('zoom').equals(nextViewport.get('zoom'));
      const didCenterUpdate = !oldViewport.get('center').equals(nextViewport.get('center'));

      return (didZoomUpdate || didCenterUpdate);
    }
    return false;
  }

  _setPopupFromUrl = (params, numTries) => {
    const state = this.context.store.getState();

    if (this.pendingPopup) {
      clearTimeout(this.pendingPopup);
    }

    const results = DatasetSelectors.getDatasetFeatureById(state, params.placeId);
    if(results.length > 0) {
      let feature = results[0];
      let coordinates = feature.geometry.coordinates;
      this.props.setPopup(coordinates[0], coordinates[1], feature);

      if (!params.lat && !params.lng && !params.zoom) {
        this.props.setViewport({
          center: coordinates,
          zoom: [17],
        });
      }
    }
    else if (--numTries > 0) {
      this.pendingPopup = setTimeout(() => {
        this._setPopupFromUrl(params, numTries);
      }, 100);
    }
  }

  render(): ?React.Element<any> {
    const title = (this.props.title) ? this.props.title + " | " + config.TITLE
      : config.TITLE;
    return (
      <DocumentTitle title={title}>
        <main>
          <Menu />
          <Omnibox />
          <SidePanel />
          <Map />
        </main>
      </DocumentTitle>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
